export default __webpack_public_path__ + "static/key-findings-figure-4a-2025-5bba317f396972dbe758bf2fa7dd69b7.png";